(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["base-slide-show"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  let currentSlide = 0;

  // Select slides dynamically
  function getSlides() {
    return document.querySelectorAll(".slides .slide");
  }

  // Show the current slide based on the index
  function showSlide(index) {
    const slides = getSlides();
    slides.forEach((slide, i) => {
      slide.style.display = i === index ? "block" : "none";
      setTimeout(()=> slide.style.opacity = i === index ? "1" : "0",1)
       
    });
  }

  // Move to the next or previous slide
  function moveSlide(step) {
    const slides = getSlides();
    currentSlide = (currentSlide + step + slides.length) % slides.length;
    showSlide(currentSlide);
  }

  // Add auto-slide functionality
  setInterval(() => {
    moveSlide(1); // Automatically move to the next slide every 5 seconds
  }, 5000);

  // Initialize the slideshow by showing the first slide
  showSlide(currentSlide);

  // Attach click event handlers to buttons
  document.querySelector('.prev').addEventListener('click', function() {
    moveSlide(-1);
  });

  document.querySelector('.next').addEventListener('click', function() {
    moveSlide(1);
  });
});

  } catch(e) { console.error(e); }
})();
})();
